// extracted by mini-css-extract-plugin
module.exports = {"leftSideWrapper":"_1-EN4","center":"_2GC1D","backBtn":"_23mGY"};